import { Component, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  showHelp = false;

  constructor(private eRef: ElementRef){}
  toggleHelp(event: Event){
    event.stopPropagation();

    this.showHelp = !this.showHelp;
  }

  @HostListener('document:click',['$event'])
  closeHelp(event: Event){
    if( !this.eRef.nativeElement.contains(event.target)){
      
      this.showHelp = false;
    }
  }

}
